import { isAxiosError } from 'axios'

export const AI_DISABLED_ERROR_CODE = 'AI_DISABLED_FOR_CAMPAIGN'
export const AI_DISABLED_MESSAGE = 'Servicios de IA deshabilitados para esta campaña'
export const AI_DISABLED_TOAST_MESSAGE =
  'Las funcionalidades de ia han sido deshabilitadas para esta campaña'

export const isAiDisabledError = (error: unknown) =>
  isAxiosError(error) && error.response?.status === 403
